import { useShallow } from 'zustand/shallow';

export function pick<T extends object, K extends keyof T>(obj: T, keys: K[]): Pick<T, K> {
  return keys.reduce(
    (acc, key) => {
      acc[key] = obj[key];
      return acc;
    },
    {} as Pick<T, K>
  );
}

export const useSelector = <T extends object, K extends keyof T>(fields: K[]) =>
  useShallow((state: T) => pick(state, fields));
